import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {setIntendedUrl} from '../utils/auth';
import PropTypes from 'prop-types';
import {useAuth} from '../context/auth';
import useSeo from "../components/seo";
import {AppRoutes} from "../utils/constants";

function AuthRoute ({ component: Component, title, ...rest }) {
  let {authenticated} = useAuth();
  const location = useLocation();

  if (!authenticated) {
    setIntendedUrl(location.pathname);
  }

  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout || ((page) => page);
  const appWithLayout = getLayout(<Component {...rest} />);

  //set the meta params
  const getSEO = Component.getSEO || (()=>{});
  useSeo(getSEO());

  return (
    authenticated ? appWithLayout
      : <Navigate to={AppRoutes.login.path} replace state={{from: location}} />
  )
}

AuthRoute.displayName = 'Auth Route';

AuthRoute.propTypes = {
  component: PropTypes.func.isRequired,
  rest: PropTypes.object,
  location: PropTypes.object,
  title: PropTypes.string
};

export default AuthRoute;
